import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/i18n/useT";

export default function JournalPage() {
  const t = useT();
  const j = t.journal;
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/journal").then(({ data }) => setPosts(data.posts || [])); }, []);
  return (
    <div data-testid="journal-page" className="br-container py-20 md:py-28">
      <header className="mb-20 max-w-2xl br-fade-in">
        <div className="br-eyebrow mb-4">{j.eyebrow}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-espresso leading-tight">{j.heroTitle}</h1>
        <p className="mt-6 text-base font-light text-dark-walnut leading-relaxed max-w-xl">{j.heroBody}</p>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-x-12 md:gap-y-24">
        {posts.map((post, i) => (
          <Link key={post.slug} to={`/journal/${post.slug}`} data-testid={`journal-card-${post.slug}`} className={`group br-fade-in ${i % 2 === 1 ? "md:mt-24" : ""}`}>
            <div className="aspect-[4/5] overflow-hidden bg-walnut/5">
              <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
            </div>
            <div className="mt-6">
              <h2 className="font-serif text-2xl md:text-3xl text-espresso leading-tight group-hover:text-walnut transition-colors">{post.title}</h2>
              <p className="mt-3 text-base font-light text-dark-walnut leading-relaxed">{post.excerpt}</p>
              <div className="mt-5 text-[11px] uppercase tracking-[0.3em] text-walnut">{j.readStory}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}